<template>
  <div>
    <header class="mb-6">
      <h1 class="text-2xl font-bold">Device suitability</h1>
      <p class="text-ink-soft text-sm mt-1">{{ total }} suitability tests (QC / monogas)</p>
    </header>

    <div class="card overflow-hidden">
      <div class="overflow-x-auto">
        <table class="table">
          <thead>
            <tr>
              <th>File</th>
              <th>Date</th>
              <th>Device</th>
              <th>Daily</th>
              <th>Status</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in items" :key="s.uuid">
              <td class="font-mono text-xs">
                <a v-if="s.file_path" :href="storageUrl(s.file_path)" target="_blank" class="text-brand-600">
                  {{ s.filename }}
                </a>
                <span v-else>{{ s.filename }}</span>
              </td>
              <td>{{ fmtDate(s.file_created_at) }}</td>
              <td>{{ s.device.name }}</td>
              <td>
                <span v-if="s.daily" class="pill pill-brand">daily</span>
                <span v-else class="pill pill-muted">setup</span>
              </td>
              <td><span class="pill" :class="statusPill(s.status)">{{ s.status || 'n/a' }}</span></td>
              <td class="text-ink-soft text-xs max-w-xs truncate">{{ s.message }}</td>
            </tr>
            <tr v-if="!loading && !items.length">
              <td colspan="6" class="text-center text-ink-muted py-10">No suitability tests.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="loading" class="py-10 text-center text-ink-soft">
        <font-awesome-icon icon="circle-notch" spin /> Loading…
      </div>

      <div class="flex items-center justify-between px-4 py-3 border-t border-gray-50">
        <span class="text-xs text-ink-muted">Page {{ page }} of {{ pageCount }}</span>
        <div class="flex gap-2">
          <button class="btn btn-secondary btn-sm" :disabled="page <= 1" @click="go(page - 1)">Prev</button>
          <button class="btn btn-secondary btn-sm" :disabled="page >= pageCount" @click="go(page + 1)">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api, storageUrl } from 'helpers/api'
import { fmtDate, statusPill } from 'helpers/format'

export default {
  data() {
    return { items: [], total: 0, page: 1, perPage: 20, loading: true }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.perPage))
    },
  },
  created() {
    this.load()
  },
  methods: {
    fmtDate,
    statusPill,
    storageUrl,
    async load() {
      this.loading = true
      try {
        const res = await api.listSuitability({ page: this.page, perPage: this.perPage })
        this.items = res.data
        this.total = res.total
      } finally {
        this.loading = false
      }
    },
    go(p) {
      this.page = p
      this.load()
    },
  },
}
</script>
